var _style, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSplash5(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "575px",
    height: "449px",
    viewBox: "0 0 575 449",
    style: {
      enableBackground: "new 0 0 575 449"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:url(#SVGID_1_);}\n\t.st1{fill:url(#SVGID_2_);}\n")), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 206.6431,
    y1: 226.8486,
    x2: 379.7928,
    y2: -99.7397,
    gradientTransform: "matrix(1 0 0 -1 0 450)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F0F4FB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D2E3F6"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M420.9,281.8c-24.5-35.3-6.7-91.6-48.2-138.9c-18.8-21.5-91.1-40.6-140.8,16.2C174.9,197,23.1,186.4,1.7,316.3 c-5.4,43.4,34.1,104.3,83.2,104.3h413.4l48-67.9C513.4,283.1,466.5,347.6,420.9,281.8z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 185.2114,
    y1: 192.8429,
    x2: 575.2115,
    y2: 192.8429,
    gradientTransform: "matrix(1 0 0 -1 0 450)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F0F3FB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D2E3F6"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M377.6,163.5C310.2,73.1,263,91.1,237,107.9c-62.3,40.2-10.5,123.1-11.7,153.2c-1.1,30.1-52.8,43.7-37.1,108.9 c4.1,17,24,50.1,48,50.1l254.7,0.1c59.5,0,84.3-49.7,84.3-85.9C575.3,227.2,445,253.9,377.6,163.5z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSplash5);
export default __webpack_public_path__ + "static/media/splash-5.5f2b6cd5287a8eac193ff9b2f5980d82.svg";
export { ForwardRef as ReactComponent };